export const MUTATION_TYPES = {
  RESET: 'reset', //Reset State when is destroy patern wrapper
  SET_REQUESTS: 'set-requests',
  SET_CURRENT_FILTERS: 'set-current-filters',
  SET_FILTERS: 'set-filters',
  SET_CENTERS: 'setCenters',
  SET_REGIONS: 'setRegions',
  SET_MUNICIPALITIES: 'setMunicipalities',
  SET_SCHOOLS: 'setSchools',
};

export const ACTION_TYPES = {
  RESET: 'reset',
  GET_REQUESTS: 'getRequests',
  GET_FILTERS: 'getFilters',
  GET_CENTERS: 'getCenters',
  GET_REGIONS: 'getRegions',
  GET_MUNICIPALITIES: 'getMunicipalities',
  GET_SCHOOLS: 'getSchools',
};
